import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";

export const CaregiverAckCard = ({ clientId }) => {
  const [rows, setRows] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/clients/${clientId}/caregiver-acks`);
      setRows(data.caregivers || []);
    } catch { setRows([]); }
  }, [clientId]);

  useEffect(() => { load(); }, [load]);

  if (rows === null) return null;

  return (
    <div className="mb-6 rounded-xl border border-stone-200 bg-white p-5 shadow-sm" data-testid="caregiver-ack-card">
      <p className="font-heading text-sm font-semibold text-stone-900">Care plan acknowledgments</p>
      <p className="mt-0.5 text-xs text-stone-400">Each caregiver must acknowledge this care plan on their first day — they may not work a second day until it's done.</p>
      {rows.length === 0 ? (
        <p className="mt-2 text-xs text-stone-400" data-testid="ack-empty">No caregivers with visits on record yet.</p>
      ) : (
        <div className="mt-3 space-y-1.5" data-testid="ack-list">
          {rows.map((r, i) => (
            <div key={r.user_id || r.name || i} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-stone-100 px-3 py-1.5 text-xs" data-testid={`ack-row-${i}`}>
              <span className="text-stone-700">
                <span className="font-medium">{r.name || "Unknown"}</span>
                <span className="text-stone-400"> · first day {r.first_date || "—"} · {r.days} day(s) worked</span>
              </span>
              {r.acked ? (
                <span className={`inline-flex items-center gap-1 font-medium ${r.current_version ? "text-[#1e8449]" : "text-[#8a5d14]"}`} data-testid={`ack-status-${i}`}>
                  <CheckCircle size={13} weight="fill" />
                  Acknowledged {r.ack_date}{r.current_version ? "" : " (older plan version — re-acknowledge)"}
                </span>
              ) : (
                <span className={`inline-flex items-center gap-1 font-semibold ${r.blocked ? "text-[#C0392B]" : "text-[#8a5d14]"}`} data-testid={`ack-status-${i}`}>
                  <WarningCircle size={13} weight="fill" />
                  {r.blocked ? "Not acknowledged — worked past first day" : "Not acknowledged yet"}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
